import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=a53976c6&scoped=true&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=a53976c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53976c6",
  null
  
)

export default component.exports